import React from 'react'
// import { Link } from 'react-router-dom';
// import AnchorLink from 'react-anchor-link-smooth-scroll'

import SliderImg from '../../images/slider/slide-9-2.jpg'
// import arrow from '../../images/bottom-arrow.svg'

const Hero9 = () => {
//   const ClickHandler = () => {
//     window.scrollTo(10, 0)
//   }
  return (
    <section
      className="wpo-hero-static-s4"
      style={{ backgroundImage: `url(${SliderImg})` }}
    >
      <div className="wrapper">
        <h2 className="">
          <span>Contact Us</span>
        </h2>
        <div className="content fade_bottom">
          {/* <p>Blaze is a trailblazing architecture agency renowned for its innovative approach to design, where
                        creativity meets functionality.</p>
                    <Link onClick={ClickHandler} to="/about" className="theme-btn"> <span className="rolling-text">Explore Our Work</span></Link> */}
        </div>
      </div>

      {/* <AnchorLink href="#about" className="scroll-btn fade_bottom">
        <div className="scroll-befor">
          <img src={arrow} alt="" />
        </div>
        <span>Scroll For More</span>
      </AnchorLink> */}
    </section>
  )
}

export default Hero9
